<template>
    <div class="window-wrapper window-client-check-error-2">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">Не удалось отправить письмо по следующим email: {{getRecepients(letter.recepientList)}}.<br> Вы можете назначить других адресатов из
                        списка контактных лиц Клиента.
                    </div>

                    <div class="form-field-input-2">
                        <label>Кому</label>
                        <div class="field-input-wrapper">
                            <select v-model="addresseeId" class="select-contacts">
                                <option :value="0">Не выбрано</option>
                                <option v-for="addressee in addresseeList" :value="addressee.id">{{
                                        addressee.surname + ' ' + addressee.name + (addressee.patronymic == null ? '' : ' ' + addressee.patronymic)
                                    }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="button-block">
                        <button @click="sendLetter" class="button button-dark button-close-window" :disabled="addresseeId === 0">Отправить</button>
                        <button @click="closeWindow" class="button button-opacity button-close-window">Отмена</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "SendError2Window",
    props: ["addresseeList", "letter"],
    data() {
        return {
            addresseeId: 0
        }
    },
    methods: {
        closeWindow() {
            $('.window-client-check-error-2').removeClass('window-open');
            $('body').removeClass('blocked');
            this.addresseeId = 0;
        },
        sendLetter() {
            this.$emit('resendLetter', this.letter, this.addresseeId);
            this.closeWindow();
        },
        getRecepients(recepientList) {
            if (recepientList) {
                return recepientList.split(',').join(', ');
            }
            return "";
        }
    }
}
</script>

<style scoped>

</style>